// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-attachment-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto; /* Re-enable pointer events for the modal overlay */
  z-index: 2000;
}

.file-attachment-modal-content {
  position: relative;
  width: 500px;
  height: 500px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.file-attachment-modal-close-btn {
  position: absolute;
  top: -16px; /* Position button halfway outside the top edge */
  right: -16px; /* Position button halfway outside the right edge */
  background-color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.file-attachment-modal-close-btn i {
  color: #555;
  font-size: 16px;
}

.file-attachment-modal-actions {
  position: absolute;
  top: 60px;
  right: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 10;
}

.file-attachment-modal-action-btn {
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: background-color 0.2s ease;
}

.file-attachment-modal-action-btn i {
  color: black;
  font-size: 16px;
}

.file-attachment-modal-react-icon {
  width: 18px;
  height: 18px;
}

.file-attachment-modal-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
}

.file-attachment-modal-icon {
  width: 128px;
  height: 128px;
  margin-bottom: 20px;
}

.file-attachment-modal-filename {
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.file-attachment-modal-file-info,
.file-attachment-modal-file-size {
  font-size: 16px;
  color: #777;
}

.file-attachment-modal-reactions {
  position: absolute;
  bottom: 20px;
  left: 20px;
}

.file-attachment-modal-emoji-picker-container {
  position: fixed;
  top: 350px;
  right: 250px;
  z-index: 2002;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/FileAttachmentModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB,EAAE,mDAAmD;EACzE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,iDAAiD;EAC7D,YAAY,EAAE,mDAAmD;EACjE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4EAA4E;EAC5E,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB","sourcesContent":[".file-attachment-modal-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto; /* Re-enable pointer events for the modal overlay */\n  z-index: 2000;\n}\n\n.file-attachment-modal-content {\n  position: relative;\n  width: 500px;\n  height: 500px;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.file-attachment-modal-close-btn {\n  position: absolute;\n  top: -16px; /* Position button halfway outside the top edge */\n  right: -16px; /* Position button halfway outside the right edge */\n  background-color: white;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.file-attachment-modal-close-btn i {\n  color: #555;\n  font-size: 16px;\n}\n\n.file-attachment-modal-actions {\n  position: absolute;\n  top: 60px;\n  right: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 10;\n}\n\n.file-attachment-modal-action-btn {\n  background-color: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n  transition: background-color 0.2s ease;\n}\n\n.file-attachment-modal-action-btn i {\n  color: black;\n  font-size: 16px;\n}\n\n.file-attachment-modal-react-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.file-attachment-modal-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n}\n\n.file-attachment-modal-icon {\n  width: 128px;\n  height: 128px;\n  margin-bottom: 20px;\n}\n\n.file-attachment-modal-filename {\n  font-size: 20px;\n  font-weight: 500;\n  color: #333;\n}\n\n.file-attachment-modal-file-info,\n.file-attachment-modal-file-size {\n  font-size: 16px;\n  color: #777;\n}\n\n.file-attachment-modal-reactions {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n}\n\n.file-attachment-modal-emoji-picker-container {\n  position: fixed;\n  top: 350px;\n  right: 250px;\n  z-index: 2002;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
